// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__33kQW","tab":"ProcedureTabs_tab__2Y0ZR"};